import Vue from "vue";
import App from "./App";
import router from "./router";
import "./comm/js/font.js";
import "./comm/style/common.css";
import "./comm/style/all.scss";
import "../all_other.scss";
import "./comm/style/element-ui.css";
import "./comm/js/androidFont.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/comm/style/font.css";
import "lib-flexible/flexible.js";
import "vant/lib/index.css";
Vue.use(ElementUI);
import axios from "./comm/js/axios_config";
import api from "./api/api_config";

import Directives from "./directives";
Vue.use(Directives);
import { Toast } from "vant";
Vue.$toast = Toast;
Vue.prototype.$api = api;
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js